import React, { Component, Fragment } from 'react'
// @material-ui/icons
import CloudDownload from '@material-ui/icons/CloudDownload'
import Done from '@material-ui/icons/Done'
//core components
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
import GridContainer from '../Grid/GridContainer.jsx'
import GridItem from '../Grid/GridItem.jsx'
import Button from '../CustomButtons/Button.jsx'
import CustomInput from '../CustomInput/CustomInput.jsx'
import InfoArea from '../InfoArea/InfoArea'
import whitepaper from '../../assets/bitnational_whitepaper.pdf'

import styles from '../../assets/jss/material-kit-pro-react/views/componentsSections/footerStyle.jsx'
import { navigateTo } from 'gatsby-link'

class WhitePaper extends Component {
  state = {
    email: '',
    emailLoading: false,
    signupSuccess: false,
    validationError: '',
  }

  handleChange = e => {
    this.setState({ email: e.target.value })
  }
  handleSubmit = e => {
    if (typeof window !== 'undefined') {
      e.preventDefault()
      const { email } = this.state
      if (
        !email ||
        !email.match(
          /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g
        )
      ) {
        this.setState({ validationError: 'Please enter an email' })
        return false
      }

      const data = { Data: { Email: email, EmailPerm: '1' } }

      try {
        this.setState({ emailLoading: true })
        fetch(
          'https://clientapi.benchmarkemail.com/Contact/15915579/ContactDetails',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json; charset=utf-8',
              AuthToken: '2298B27F-02E9-4144-8548-95C32C169675',
            },
            body: JSON.stringify(data),
          }
        )
          .then(response => response.json())
          .catch(error => {
            console.error({ Error: error })
            return false
          })
          .then(response => {
            this.setState({
              emailLoading: false,
              email: '',
              signupSuccess: true,
            })
            navigateTo(whitepaper)
          })
      } catch (error) {
        console.error(error)
      }
    }
  }
  render() {
    return (
      <Fragment>
        {!this.state.signupSuccess ? (
          <form
            style={{ opacity: this.state.emailLoading ? 0.5 : 1 }}
            onSubmit={this.handleSubmit}
          >
            <Grid container alignItems="center">
              <GridItem xs={9} md={10}>
                <CustomInput
                  autoComplete="email"
                  inputProps={{
                    onChange: this.handleChange,
                    value: this.state.email,
                  }}
                  white={this.props.white}
                  error={this.state.validationError.length}
                  id="contactemail"
                  labelText={
                    this.state.validationError
                      ? this.state.validationError
                      : 'Your Email...'
                  }
                  formControlProps={{
                    fullWidth: true,
                  }}
                />
              </GridItem>
              <GridItem xs={1} md={2}>
                <Button onClick={this.handleSubmit} justIcon>
                  <CloudDownload />
                </Button>
              </GridItem>
            </Grid>
          </form>
        ) : (
          <InfoArea
            title="Success"
            description="You've been added to the email list"
            icon={Done}
            iconColor="success"
          />
        )}
      </Fragment>
    )
  }
}

export default withStyles(styles)(WhitePaper)



// WEBPACK FOOTER //
// ./src/components/Form/Whitepaper.jsx